'use strict'

import { getCitiesFromState } from '../services'

import types from './types'

const { FETCH_CITIES_FROM_STATE } = types

function fetchCitiesFromState(data) {
  return dispatch =>
    getCitiesFromState(data).then(address => {
      dispatch({
        type: FETCH_CITIES_FROM_STATE,
        state: address
      })

      return address
    })
}

export default fetchCitiesFromState



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchCitiesFromState.js